import React, {useMemo} from 'react';
import {InputSlider} from 'components';
import {suffixRemove} from 'utils';
import {useEditorStyle} from 'hooks';
import type {IChildrenProps} from './Editor.Inspector';

interface IEditorInspectorDimensionProps extends IChildrenProps {}

const EditorInspectorDimension = ({style, setProp}: IEditorInspectorDimensionProps) => {
  const defaultValuesDimensions = useMemo(() => {
    const dimensions = [style?.width, style?.height] as string[];
    return dimensions.map(d => suffixRemove('%', d));
  }, [style?.width, style?.height]);

  const defaultValuesDimensionsMax = useMemo(() => {
    const dimensions = [style?.maxWidth, style?.maxHeight] as string[];
    return dimensions.map(d => suffixRemove('px', d));
  }, [style?.maxWidth, style?.maxHeight]);

  const dimensions = {
    width: 'Width',
    height: 'Height',
  };

  const dimensionsMax = {
    maxWidth: 'Max Width',
    maxHeight: 'Max Height',
  };

  const {updateStyle} = useEditorStyle({setProp});

  return (
    <div>
      <h4 className="font-medium text-sm text-slate-800 dark:text-white pb-4">Dimension</h4>
      <div className="flex flex-col gap-3">
        {Object.entries(dimensions).map(([k, v], index) => {
          return (
            <InputSlider
              key={k}
              label={v}
              suffix="%"
              defaultValue={defaultValuesDimensions[index]}
              onSlide={value => {
                updateStyle(k as keyof typeof dimensions, `${value}%`);
              }}
            />
          );
        })}
        {Object.entries(dimensionsMax).map(([k, v], index) => {
          return (
            <InputSlider
              key={k}
              label={v}
              suffix="px"
              min={32}
              max={4098}
              defaultValue={defaultValuesDimensionsMax[index]}
              onSlide={value => {
                updateStyle(k as keyof typeof dimensionsMax, `${value}px`);
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(EditorInspectorDimension);
